import usePrivateLink from "../../config/usePrivateLink";
import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { createusers, editusers, userDelete } from "../../../api/userService";
import Swal from "sweetalert2";
import {
  closeModal,
  formatDate,
  ToastMain,
  SweetAlertShow,
} from "../../master/Master";
import { GetRole, GetUser } from "../../../api/UserRoleServices";
import { Link } from "react-router-dom";
import UserHeader from "./UserHeader";
import { StaffList } from "../../../api/Staff";

const UsersPage = () => {
  const hasAccess = usePrivateLink();
  const [data, setData] = useState([]);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staff, setStaff] = useState([]);
  const [selectedStaffData, setSelectedStaffData] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    password: "",
    role_id: "",
  });

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await createusers(formData);
      if (response.data.status) {
        setError("");
        e.target.reset();
        getuser();
        closeModal("exampleModal");
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (userData) => {
    setLoading(true); // 🌀 Show loading spinner
    try {
      if (userData) {
        setFormData(userData);
      }
    } catch (err) {
      Swal.fire({
        icon: "Error",
        title: "View error:",
        text: err,
        confirmButtonColor: "#d33",
      });
    }
    setLoading(false); // 🌀 Hide loading spinner
  };
  const handleEdit = async (e) => {
    setLoading(true); // 🌀 Show loading spinner
    e.preventDefault();
    try {
      const formDataSubmit = new FormData(e.target);
      const dataObj = Object.fromEntries(formDataSubmit.entries());
      console.log(dataObj);
      dataObj.id = formData.id;
      const response = await editusers(dataObj);
      if (response.data.status) {
        closeModal("Edit");
        getuser();
        setError("");
        // ToastMain.fire({
        //   icon: 'success',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow("success", "Sucessfuly", response?.data?.message);
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (id) => {
    // e.preventDefault();
    console.log("Delete clicked for ID:", id);
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const response = await userDelete(id);
        if (response.data.status) {
          ToastMain.fire({
            icon: "success",
            title: "deleted successfully!",
          }).then(() => {
            getuser();
          });
        }
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    }
  };
  const getRoles = async () => {
    setLoading(true); // 🌀 Show loading spinner
    try {
      const response = await GetRole();
      const rolesArray = response?.data?.data || [];
      setRoles(rolesArray);
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    }
    setLoading(false); // 🌀 Hide loading spinner
  };

  const getuser = async () => {
    setLoading(true); // 🌀 Show loading spinner
    try {
      const response = await GetUser();
      // setData(response.data.data);

      if (response?.data?.status) {
        setData(response.data.data);
      } else {
        setError("Failed to fetch users.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const fetchstaff = async () => {
    setLoading(true);
    try {
      const response = await StaffList();
      if (response?.data?.status) {
        setStaff(response.data.data);
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch {}
  };

  useEffect(() => {
    getuser();
    getRoles();
    fetchstaff();
  }, []);
  const statusClassMap = {
    0: "text-success ", // Active - Green
    1: "text-primary", // Complete - Blue
    2: "text-warning", // Upcoming - Yellow/Orange
  };
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Nav />
          <div className="layout-page">
            <Header />
            <div className="content-wrapper">
              <div className="container-fluid p-4">
                <div className="row">
                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <UserHeader data={"User Portal"} />
                    </div>
                    <div className="col-md-9">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center mb-4">
                            <h4 className="text-primary fw-bold mb-0">
                              Users List
                            </h4>
                            {hasAccess("/settings/users/add") && (
                              <button
                                className="btn btn-primary d-inline-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                              >
                                <span className="icon">+</span>
                                <span className="text ms-2">New User</span>
                              </button>
                            )}
                          </div>

                          <div className="table-responsive d-flex justify-content-center">
                            <table className="table table-hover table-bordered text-center align-middle">
                              <thead
                                className="text-white"
                                style={{ backgroundColor: "#007bff" }}
                              >
                                <tr>
                                  <th>#</th>
                                  <th>Name</th>
                                  <th>Mobile</th>
                                  <th>Role</th>
                                  <th>Created At</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(data) && data.length > 0 ? (
                                  data.map((user, index) => (
                                    <tr key={user.id}>
                                      <td>{index + 1}</td>
                                      <td className="text-capitalize">
                                        {user.name}
                                      </td>
                                      <td>{user.phone || "-"}</td>
                                      <td>{user.role?.name || "-"}</td>
                                      <td>{formatDate(user.created_at)}</td>

                                      <td>
                                        <div className="demo-inline-spacing py-0 my-0">
                                          <div
                                            className="btn-group py-0 my-0"
                                            id="hover-dropdown-demo"
                                          >
                                            <button
                                              type="button"
                                              className="btn dropdown-toggle py-0 my-0"
                                              data-bs-toggle="dropdown"
                                              data-trigger="hover"
                                              aria-expanded="false"
                                            >
                                              <i className="bi bi-three-dots-vertical" />
                                            </button>
                                            <ul className="dropdown-menu py-0">
                                              <li>
                                                {hasAccess(
                                                  "/settings/users/info",
                                                ) && (
                                                  <Link
                                                    to={``}
                                                    onClick={() =>
                                                      handleView(user)
                                                    }
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#view"
                                                    className="dropdown-item"
                                                  >
                                                    <i className="bi bi-eye text-success mx-1"></i>
                                                    View
                                                  </Link>
                                                )}
                                              </li>
                                              <li>
                                                {hasAccess(
                                                  "/settings/users/edit",
                                                ) && (
                                                  <Link
                                                    to={``}
                                                    className="dropdown-item"
                                                    onClick={() =>
                                                      handleView(user)
                                                    }
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#Edit"
                                                  >
                                                    <i className="bi bi-pencil-square text-primary mx-1"></i>
                                                    Edit
                                                  </Link>
                                                )}
                                              </li>
                                              <li>
                                                {hasAccess(
                                                  "/settings/users/delete",
                                                ) && (
                                                  <button
                                                    className="dropdown-item"
                                                    onClick={() =>
                                                      Swal.fire({
                                                        title: "Are you sure?",
                                                        text: "This action will permanently delete the Enquiry!",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor:
                                                          "#d33",
                                                        cancelButtonColor:
                                                          "#6c757d",
                                                        confirmButtonText:
                                                          "Yes, delete it!",
                                                        cancelButtonText:
                                                          "Cancel",
                                                      }).then(
                                                        async (result) => {
                                                          if (
                                                            result.isConfirmed
                                                          ) {
                                                            handleDelete(
                                                              user.id,
                                                            );
                                                          }
                                                        },
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-trash-fill mx-1 text-danger"></i>{" "}
                                                    Delete
                                                  </button>
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="6" className="text-muted">
                                      No users found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div className="modal fade" id="exampleModal" tabIndex={-1}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-3">
              <h5 className="modal-title">Add New User</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                  <div className="col-md-6 mb-6 form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="staff_id"
                      required
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const selected = staff.find(
                          (s) => s.id === parseInt(selectedId),
                        );
                        if (selected) {
                          setSelectedStaffData({
                            name: selected.name || "",
                            phone: selected.phone || "",
                            email: selected.email || "",
                          });
                        } else {
                          setSelectedStaffData({
                            name: "",
                            phone: "",
                            email: "",
                          });
                        }
                      }}
                    >
                      <option value="">Select Staff</option>
                      {staff.map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name}
                        </option>
                      ))}
                    </select>

                    <label>
                      Select Staff <span className="text-danger">*</span>
                    </label>
                    <span className="text-danger">{error?.staff_id ?? ""}</span>
                  </div>

                  <div className="col-md-6 mb-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control input-lowercase"
                      name="name"
                      placeholder="User Name"
                      value={selectedStaffData.name}
                      onChange={(e) =>
                        setSelectedStaffData((prev) => ({
                          ...prev,
                          name: e.target.value,
                        }))
                      }
                      required
                    />

                    <label>
                      User Name <span className="text-danger">*</span>
                    </label>
                    <span className="text-danger">{error?.name ?? ""}</span>
                  </div>
                  <div className=" col-md-6 mb-6 form-floating form-floating-outline">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      placeholder="Mobile"
                      maxLength={10}
                      pattern="\d{10}"
                      value={selectedStaffData.phone}
                      onChange={(e) =>
                        setSelectedStaffData((prev) => ({
                          ...prev,
                          phone: e.target.value,
                        }))
                      }
                      required
                    />

                    <label>
                      Mobile No <span className="text-danger">*</span>
                    </label>
                    <span className="text-danger">{error?.phone ?? ""}</span>
                  </div>

                  <div className="col-md-6 mb-6 form-floating form-floating-outline">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Email"
                      value={selectedStaffData.email}
                      onChange={(e) =>
                        setSelectedStaffData((prev) => ({
                          ...prev,
                          email: e.target.value,
                        }))
                      }
                      required
                    />

                    <label>
                      Email <span className="text-danger">*</span>
                    </label>
                    <span className="text-danger">{error?.email ?? ""}</span>
                  </div>
                  <div className="col-md-6 mb-6 form-floating form-floating-outline">
                    <input
                      type="password"
                      className="form-control "
                      name="password"
                      placeholder="Password"
                      required
                    />
                    <label>Password</label>
                    <span className="text-danger">
                      The Password field must be at least 10 characters
                    </span>
                    <span className="text-danger">{error?.password ?? ""}</span>
                  </div>

                  <div className="col-md-6 mb-6 form-floating form-floating-outline">
                    <select className="form-select" name="role_id" required>
                      <option value="">Select Role</option>
                      {Array.isArray(roles) &&
                        roles.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.name}
                          </option>
                        ))}
                    </select>
                    <label>
                      Role <span className="text-danger">*</span>
                    </label>
                    <span className="text-danger">{error?.role_id ?? ""}</span>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={loading} // Disable the button while loading
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Submit"
                    )}
                    {loading ? " Submitting..." : ""}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="Edit"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-label-primary p-5">
              <h5 className="modal-title">Edit User</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleEdit}>
                {/* {JSON.stringify(formData)} */}
                <input type="hidden" name="id" value={formData.id} />

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-bold">User Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control input-uppercase"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Mobile No</label>
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      maxLength={10}
                      pattern="\d{10}"
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">Password</label>
                    <input
                      type="password"
                      name="password"
                      className="form-control "
                      placeholder="Password"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="form-label fw-bold">Role</label>
                  <select
                    className="form-select"
                    name="role_id"
                    required
                    value={formData.role_id || ""} // Controlled value
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        role_id: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select Role</option>
                    {Array.isArray(roles) &&
                      roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={loading} // Disable the button while loading
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Submit"
                    )}
                    {loading ? " Submitting..." : ""}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="view"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content shadow-lg border-0">
            <div className="modal-header bg-label-primary text-white p-4">
              <h5 className="modal-title">View User</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body p-4">
              <form>
                {/* <input type="hidden" name="id" value={formData.id} /> */}

                <div className="row g-4">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-blacke">
                      User Name
                    </label>
                    <div className="fs-6 text-primary">
                      {formData.name || "—"}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-black">
                      Status
                    </label>
                    <span
                      className={`badge px-3 py-2 ${statusClassMap[formData.status] || "bg-secondary"}`}
                      style={{ fontSize: "0.9rem" }}
                      data-bs-toggle="modal"
                      data-bs-target="#Status"
                    >
                      {formData.status === "1"
                        ? "Active"
                        : formData.status === "2"
                          ? "Complete"
                          : formData.status === "0"
                            ? "Upcoming"
                            : "Unknown"}
                    </span>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-black">
                      Mobile No
                    </label>
                    <div className="fs-6 text-primary">
                      {formData.phone || "—"}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-black">
                      Email
                    </label>
                    <div className="fs-6 text-primary">
                      {formData.email || "—"}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-black">
                      Last Login
                    </label>
                    <div className="fs-6 text-primary">
                      {formData.last_login || "—"}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-black">
                      Role
                    </label>
                    <div className="fs-6 text-primary">
                      {formData.role_name || formData.role_id || "—"}
                    </div>
                  </div>
                </div>

                <div className="text-end mt-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary px-4"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersPage;
